module.exports = "/1758270514/static/img/label.svg";